<draggable-container [prefix]="data.prefix">
  <select name="userLanguage" class="userLanguage" [(ngModel)]="data.codeLang"
    (change)="changeLanguage($event)">
    <option *ngFor="let lang of availableLanguages" value="{{lang}}">
        {{lang}}
    </option>
  </select>
  <ngx-monaco-editor [options]="editorOptions"
    [(ngModel)]="data.text"></ngx-monaco-editor>
</draggable-container>

